// Centralized accent colors for consistent theming across the app.
// Import from here instead of hardcoding hex values in components.

export const COLORS = {
  income:     '#3fa4f6',  // blue  — budget income & portfolio assets
  expense:    '#ffb347',  // amber — budget expenses & portfolio liabilities
  savings:    '#6ccf7d',  // green — budget savings & tools
  notes:      '#9b72d7',  // purple — notes section
  super:      '#6a63d7',  // indigo — superannuation
} as const;

export type ColorKey = keyof typeof COLORS;
